import { useConstant } from "../../../../hooks/index.js";
import { loginForm } from "../loginFormSetup.js";
const autoFocusOrder = ["uid", "username", "password"];
function useAutoFocusEmptyField(autoFocus = "off", showUid) {
  const formApi = loginForm.useFormApi();
  return useConstant(() => {
    if (autoFocus === "off") return;
    if (!formApi) return;
    const initialValues = formApi.getInitialValues();
    for (let index = showUid ? 0 : 1; index < autoFocusOrder.length; index++) {
      const key = autoFocusOrder[index];
      const isEmpty = !initialValues[key];
      if (isEmpty) return key;
    }
    return "submit";
  });
}
export {
  useAutoFocusEmptyField
};
//# sourceMappingURL=useAutoFocusEmptyField.js.map
